import ColaboradoresPontosAdminPage from "@/Pages/Colaboradores/ColaboradoresPontosAdminPage.vue";
import FaltaJustificadaPage from "@/Pages/Colaboradores/FaltaJustificadaPage.vue";
import NovaFaltaJustificadaPage from "@/Pages/Colaboradores/NovaFaltaJustificadaPage.vue";
import GerenciarFaltasJustificadasPage from "@/Pages/Colaboradores/GerenciarFaltasJustificadasPage.vue";
import JustificativaMassaPage from "@/Pages/Colaboradores/JustificativaMassaPage.vue";
import NovaJustificativaMassaPage from "@/Pages/Colaboradores/NovaJustificativaMassaPage.vue";
import MeusPontosPage from "@/Pages/Colaboradores/MeusPontosPage.vue";
import FeriadosPage from "@/Pages/Feriados/FeriadosPage.vue";
import BatidasRemotasPage from "@/Pages/Colaboradores/BatidasRemotasPage.vue";
import NovoRegistroRemotoPage from "@/Pages/Colaboradores/NovoRegistroRemotoPage.vue";
import GerenciarBatidasRemotasPage from "@/Pages/Colaboradores/GerenciarBatidasRemotasPage.vue";
import RegistroRemotoRegrasPage from "@/Pages/Colaboradores/RegistroRemotoRegrasPage.vue";
import GerenciarAvisosPage from "@/Pages/Colaboradores/GerenciarAvisosPage.vue";
import MeuBancoHorasPage from "@/Pages/Colaboradores/MeuBancoHorasPage.vue";
import GerenciarBancoHorasPage from "@/Pages/Colaboradores/GerenciarBancoHorasPage.vue";
import AtrasosJustificadosPage from "@/Pages/Colaboradores/AtrasosJustificadosPage.vue";
import NovoAtrasoJustificadoPage from "@/Pages/Colaboradores/NovoAtrasoJustificadoPage.vue";
import GerenciarAtrasosJustificadosPage from "@/Pages/Colaboradores/GerenciarAtrasosJustificadosPage.vue";
import GerenciarFeriasPage from "@/Pages/Colaboradores/GerenciarFeriasPage.vue";
import MinhasFeriasPage from "@/Pages/Colaboradores/MinhasFeriasPage.vue";
import authService from "@/Services/AuthService";
import store from "@/store";
import { aplicarModulos } from "./modulos";

async function carregarUsuarioAtual() {
  let currentUser = store.getters["Auth/user"];
  if (!currentUser) {
    await authService.syncUserWithStore();
    currentUser = store.getters["Auth/user"];
  }
  return currentUser;
}

function possuiPermissao(currentUser, permissions = []) {
  if (currentUser?.roleName === "super-admin") return true;
  if (!Array.isArray(permissions) || permissions.length === 0) return true;
  return permissions.some((p) => currentUser?.permissions?.includes(p));
}

function possuiPerfil(currentUser, allowedRoles = []) {
  if (!currentUser) return false;
  const userRoles = (currentUser.roles || []).map((r) => r.name);
  if (currentUser.roleName) userRoles.push(currentUser.roleName);
  return allowedRoles.some((r) => userRoles.includes(r));
}

const ROLES_COLABORADORES = ["colaborador", "lider", "admin", "super-admin", "TI"];

const ROLES_GESTORES = ["TI", "admin", "super-admin", "lider"];

async function redirecionarSemColaborador(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (
    !possuiPerfil(currentUser, ROLES_COLABORADORES) ||
    !possuiPermissao(currentUser, ["colaboradores.meusPontos"])
  ) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoGestor(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (
    !possuiPerfil(currentUser, ROLES_GESTORES) ||
    !possuiPermissao(currentUser, ["colaboradores.pontos"])
  ) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoFaltaJustificada(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.faltasJustificadas.solicitar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoGestorFalta(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.faltasJustificadas.gerenciar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoAtrasoJustificado(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.atrasosJustificados.solicitar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoGestorAtraso(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.atrasosJustificados.gerenciar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoBatidaRemota(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.batidasRemotas.solicitar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoGestorBatidaRemota(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.batidasRemotas.gerenciar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoGestorAvisos(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.avisos.gerenciar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoFeriado(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["feriados.gerenciar"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoJustificativaMassa(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (!possuiPermissao(currentUser, ["colaboradores.justificativaMassa"])) {
    return next({ name: "home" });
  }

  return next();
}

async function redirecionarSemPermissaoGestorFerias(to, from, next) {
  const currentUser = await carregarUsuarioAtual();

  if (
    !possuiPerfil(currentUser, ROLES_GESTORES) &&
    !possuiPermissao(currentUser, ["colaboradores.ferias.gerenciar", "colaboradores.pontos"])
  ) {
    return next({ name: "home" });
  }

  return next();
}

const rotas = [
  {
    path: "/colaboradores/meus-pontos",
    name: "colaboradores.meusPontos",
    component: MeusPontosPage,
    beforeEnter: redirecionarSemColaborador,
  },
  {
    path: "/colaboradores/minhas-ferias",
    name: "colaboradores.minhasFerias",
    component: MinhasFeriasPage,
    beforeEnter: redirecionarSemColaborador,
  },
  {
    path: "/colaboradores/ferias/gerenciar",
    name: "colaboradores.ferias.gerenciar",
    component: GerenciarFeriasPage,
    beforeEnter: redirecionarSemPermissaoGestorFerias,
  },
  {
    path: "/colaboradores/pontos",
    name: "colaboradores.pontos",
    component: ColaboradoresPontosAdminPage,
    beforeEnter: redirecionarSemPermissaoGestor,
  },
  {
    path: "/colaboradores/faltas-justificadas",
    name: "colaboradores.faltasJustificadas",
    component: FaltaJustificadaPage,
    beforeEnter: redirecionarSemPermissaoFaltaJustificada,
  },
  {
    path: "/colaboradores/faltas-justificadas/nova",
    name: "colaboradores.faltasJustificadas.nova",
    component: NovaFaltaJustificadaPage,
    beforeEnter: redirecionarSemPermissaoFaltaJustificada,
  },
  {
    path: "/colaboradores/faltas-justificadas/gerenciar",
    name: "colaboradores.faltasJustificadas.gerenciar",
    component: GerenciarFaltasJustificadasPage,
    beforeEnter: redirecionarSemPermissaoGestorFalta,
  },
  {
    path: "/colaboradores/atrasos-justificados",
    name: "colaboradores.atrasosJustificados",
    component: AtrasosJustificadosPage,
    beforeEnter: redirecionarSemPermissaoAtrasoJustificado,
  },
  {
    path: "/colaboradores/atrasos-justificados/novo",
    name: "colaboradores.atrasosJustificados.novo",
    component: NovoAtrasoJustificadoPage,
    beforeEnter: redirecionarSemPermissaoAtrasoJustificado,
  },
  {
    path: "/colaboradores/atrasos-justificados/gerenciar",
    name: "colaboradores.atrasosJustificados.gerenciar",
    component: GerenciarAtrasosJustificadosPage,
    beforeEnter: redirecionarSemPermissaoGestorAtraso,
  },
  {
    path: "/colaboradores/batidas-remotas",
    name: "colaboradores.batidasRemotas",
    component: BatidasRemotasPage,
    beforeEnter: redirecionarSemPermissaoBatidaRemota,
  },
  {
    path: "/colaboradores/batidas-remotas/novo",
    name: "colaboradores.batidasRemotas.novo",
    component: NovoRegistroRemotoPage,
    beforeEnter: redirecionarSemPermissaoBatidaRemota,
  },
  {
    path: "/colaboradores/batidas-remotas/gerenciar",
    name: "colaboradores.batidasRemotas.gerenciar",
    component: GerenciarBatidasRemotasPage,
    beforeEnter: redirecionarSemPermissaoGestorBatidaRemota,
  },
  {
    path: "/administracao/configuracoes/registro-remoto",
    name: "colaboradores.batidasRemotas.regras",
    component: RegistroRemotoRegrasPage,
    beforeEnter: redirecionarSemPermissaoGestorBatidaRemota,
  },
  // Endereço antigo: a tela agora fica em Administração > Configurações.
  {
    path: "/colaboradores/batidas-remotas/regras",
    redirect: { name: "colaboradores.batidasRemotas.regras" },
  },
  {
    path: "/admin/feriados",
    name: "feriados.gerenciar",
    component: FeriadosPage,
    beforeEnter: redirecionarSemPermissaoFeriado,
  },
  {
    path: "/colaboradores/justificativas-massa",
    name: "colaboradores.justificativaMassa",
    component: JustificativaMassaPage,
    beforeEnter: redirecionarSemPermissaoJustificativaMassa,
  },
  {
    path: "/colaboradores/justificativas-massa/nova",
    name: "colaboradores.justificativaMassa.nova",
    component: NovaJustificativaMassaPage,
    beforeEnter: redirecionarSemPermissaoJustificativaMassa,
  },
  {
    path: "/colaboradores/avisos/gerenciar",
    name: "colaboradores.avisos.gerenciar",
    component: GerenciarAvisosPage,
    beforeEnter: redirecionarSemPermissaoGestorAvisos,
  },
  {
    path: "/colaboradores/banco-horas",
    name: "colaboradores.bancoHoras",
    component: MeuBancoHorasPage,
    beforeEnter: redirecionarSemColaborador,
  },
  {
    path: "/colaboradores/banco-horas/gerenciar",
    name: "colaboradores.bancoHoras.gerenciar",
    component: GerenciarBancoHorasPage,
    beforeEnter: redirecionarSemPermissaoGestor,
  },
];

// Rota => módulo (Administração > Configurações).
const MODULO_POR_ROTA = {
  "colaboradores.meusPontos": "meus_pontos",
  "colaboradores.minhasFerias": "minhas_ferias",
  "colaboradores.ferias.gerenciar": "gestao_ferias",
  "colaboradores.pontos": "ponto_colaboradores",
  "colaboradores.faltasJustificadas": "justificar_falta",
  "colaboradores.faltasJustificadas.nova": "justificar_falta",
  "colaboradores.faltasJustificadas.gerenciar": "aprovar_faltas",
  "colaboradores.atrasosJustificados": "justificar_atraso",
  "colaboradores.atrasosJustificados.novo": "justificar_atraso",
  "colaboradores.atrasosJustificados.gerenciar": "aprovar_atrasos",
  "colaboradores.batidasRemotas": "registro_remoto",
  "colaboradores.batidasRemotas.novo": "registro_remoto",
  "colaboradores.batidasRemotas.gerenciar": "aprovar_remotos",
  "colaboradores.batidasRemotas.regras": "aprovar_remotos",
  "feriados.gerenciar": "feriados",
  "colaboradores.justificativaMassa": "justificativa_massa",
  "colaboradores.justificativaMassa.nova": "justificativa_massa",
  "colaboradores.avisos.gerenciar": "avisos",
  "colaboradores.bancoHoras": "meu_banco_horas",
  "colaboradores.bancoHoras.gerenciar": "gestao_banco_horas",
};

export default aplicarModulos(rotas, MODULO_POR_ROTA);
